import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  dismissSellerMarketingPrompt,
  getSellerMarketingPrompt,
  saveSellerMarketingConsent,
} from "../../../api/marketing";

export const SELLER_MARKETING_OPT_IN_KEY = "riverrSellerMarketingOptIn";

/**
 * One-time ask for sellers who can be marketed to by a fulfiller.
 * Signup stores a pending yes in sessionStorage; this posts it after sign-in.
 */
export default function SellerMarketingPrompt() {
  const user = useSelector((state) => state?.currentUser?.user);
  const [prompt, setPrompt] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user?.uid) return undefined;
    let cancelled = false;
    const run = async () => {
      const raw = sessionStorage.getItem(SELLER_MARKETING_OPT_IN_KEY);
      if (raw) {
        let posted = false;
        try {
          const pending = JSON.parse(raw);
          if (pending?.fulfillerEnterpriseId) {
            await saveSellerMarketingConsent({
              fulfillerEnterpriseId: pending.fulfillerEnterpriseId,
              consent: true,
              source: "signup",
            });
          }
          posted = true;
        } catch (err) {
          posted = false;
        }
        if (!cancelled && posted) {
          try {
            sessionStorage.removeItem(SELLER_MARKETING_OPT_IN_KEY);
          } catch (err) {
            /* ignore */
          }
        }
      }
      try {
        const res = await getSellerMarketingPrompt();
        const next = res?.data?.prompts?.[0] || null;
        if (!cancelled) setPrompt(next);
      } catch (err) {
        if (!cancelled) setPrompt(null);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [user?.uid]);

  if (!prompt) return null;

  const answer = async (consent) => {
    setBusy(true);
    try {
      if (consent) {
        await saveSellerMarketingConsent({
          fulfillerEnterpriseId: prompt.fulfillerEnterpriseId,
          consent: true,
          source: "prompt",
        });
      } else {
        await dismissSellerMarketingPrompt({
          fulfillerEnterpriseId: prompt.fulfillerEnterpriseId,
        });
      }
      setPrompt(null);
    } catch (err) {
      setBusy(false);
    }
  };

  return (
    <div
      role="region"
      aria-label="Seller news"
      style={{
        margin: "12px 16px 0",
        padding: "12px 14px",
        borderRadius: 10,
        background: "#14110E",
        color: "#fff",
        display: "flex",
        gap: 12,
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <p style={{ margin: 0 }}>{prompt.copy}</p>
      <span style={{ display: "flex", gap: 8 }}>
        <button
          type="button"
          disabled={busy}
          onClick={() => answer(true)}
          style={{
            background: "#fff",
            color: "#14110E",
            border: 0,
            borderRadius: 8,
            padding: "8px 12px",
            fontWeight: 600,
          }}
        >
          Yes, email me
        </button>
        <button
          type="button"
          disabled={busy}
          onClick={() => answer(false)}
          style={{
            background: "transparent",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.4)",
            borderRadius: 8,
            padding: "8px 12px",
          }}
        >
          Not now
        </button>
      </span>
    </div>
  );
}
